// Thin, safe wrapper around the browser Web Speech API (speechSynthesis).
// Everything is guarded so this never throws in environments without support
// (older browsers, SSR, tests). No network is used.

export function speechSupported() {
  return (
    typeof window !== "undefined" &&
    "speechSynthesis" in window &&
    typeof window.SpeechSynthesisUtterance !== "undefined"
  );
}

export function stopSpeaking() {
  if (!speechSupported()) return;
  try {
    window.speechSynthesis.cancel();
  } catch {
    // ignore
  }
}

// Cancels any current utterance then speaks the given text at a calm pace.
// Returns the utterance (so callers can attach further handlers) or null.
export function speak(text) {
  if (!speechSupported() || !text) return null;
  try {
    window.speechSynthesis.cancel();
    const utterance = new window.SpeechSynthesisUtterance(String(text));
    utterance.rate = 0.95; // calm, easy to follow
    utterance.pitch = 1;
    utterance.volume = 1;
    window.speechSynthesis.speak(utterance);
    return utterance;
  } catch {
    return null;
  }
}
